import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

export const Title = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
`;

export const Text = styled.div`
  margin-top: 12px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);

  b {
    color: #EC5E59;
  }

  strong {
    font-weight: 700;
    color: rgba(0, 27, 59, 1);
  }

  a:active, a:visited, a:link {
    color: #97b8f6;
    text-decoration: underline;
  }

  a:hover {
    text-decoration: none;
  }

  ul {
    list-style-type: disc;
    margin-left: 20px;
    margin-top: 10px;
  }

  ul li {
    font-size: 16px !important;
  }

  p {
    margin-bottom: 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  span {
    color: rgba(0, 27, 59, 0.9);
    text-decoration: underline;
  }
`;

export const DataContainer = styled.div`
  margin-top: 20px;
  padding: 20px;
  background: #FFFFFF;
  border-radius: 4px;
  font-family: 'Mukta Vaani';
`;

export const DataContainerTitle = styled.h3`
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  font-weight: 700;
  margin-bottom: 20px;
`;

export const ColumnsRow = styled.div`
  display: flex;
  column-gap: 10px;
`;

export const FourColumnsRow = styled.div`
  display: flex;
  column-gap: 40px;
`;

export const DataColumn = styled.div`
  flex: 1;
`;

export const DataTitle = styled.h4`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;

export const FormulaContainer = styled.div`
  background: #FBEDD5;
  border: 1px solid #D5D9DD;
  border-radius: 8px;
  padding: 50px 30px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  max-width: 700px;

  ${p => p.maxWidth && `
    max-width: ${p.maxWidth}px;
  `}

  > * {
    flex: 1;
  }
`;

export const FormulaName = styled.div`
  padding: 16px 20px;
  text-align: center;
  border-radius: 8px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  background-color: #FEC665;
  white-space: nowrap;
`;

export const FormulaValue = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 1.333333;
  color: rgba(0, 27, 59, 0.94);
  text-align: center;
  white-space: nowrap;

  ${p => p.fontSize && `
    font-size: ${p.fontSize};
  `}

  ${p => p.lineHeight && `
    line-height: ${p.lineHeight}px;
  `}

  span {
    display: block;
    width: 100%;
    height: 1px;
    background: rgba(0, 27, 59, 0.94);
    margin: 13px 0 13px -5px;
    width: calc(100% + 10px);
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  margin-top: 4px;

  &:after {
    display: block;
    content: '%';
    color: rgba(0, 27, 59, 0.38);
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    right: 11.5px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const Input = styled.input`
  border: 1px solid #5C91F5;
  border-radius: 2px;
  padding: 4.2px 25px 4.2px 12px;
  width: 100%;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  line-height: 22px;

  ${p => p.equalPadding && `
    padding: 4.2px 12px;
  `}
  
  ${p => p.minWidth && `
    min-width: ${p.minWidth}px;
  `}

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type=number] {
    -moz-appearance: textfield;
  }

  &:active, &:focus {
    outline: none;
  }

  &:disabled {
    color: rgba(0, 27, 59, 0.38);
    border-color: #BDC0CC;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const Button = styled.button`
  background: #5C91F5;
  border-radius: 4px;
  padding: 6.5px 9.5px;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #FFFFFF;

  &:disabled {
    background: #F5F6F7;
    color: rgba(0, 27, 59, 0.38);
  }

  ${p => p.isActiveDefault && `
    background: #FF5252;
  `}

  @media (max-width: 1420px) {
    font-size: 14px;
    padding: 6px 7px;
  }
`;

export const HeaderColumn = styled.th`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500 !important;
  padding: 27px 14px;
  position: relative;
  border-bottom: 1px solid #F0F0F0;

  &:first-child {
    padding: 27px 11px;
  }

  @media (max-width: 1260px) {
    padding: 20px 10px;
  }

  &:before {
    display: block;
    content: '';
    height: 40px;
    width: 1px;
    background: #F0F0F0;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const TableCell = styled.td`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  padding: 0 8px;

  ${p => p.verticalPadding && `
    padding: 8px;
  `}

  @media (max-width: 1420px) {
    padding: 0 4px;
    font-size: 12px;
  }

  input {
    padding: 5px 12px;
    border: 1px solid #5C91F5;
    border-radius: 2px;
    font-family: 'Roboto';
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.85);
    width: 91px;
    text-align: center;
    background: #ffffff;
    transition: background 150ms ease, border-color 150ms ease,
                font-weight 150ms ease, color 150ms ease, box-shadow 150ms ease;

    &:active, &:focus {
      outline: none;
    }

    &:disabled {
      color: rgba(0,27,59,0.38);
      border-color: #BDC0CC;
    }

    @media (max-width: 1700px) {
      width: 80px;
      padding: 5px 8px;
    }

    @media (max-width: 1420px) {
      width: 60px;
      padding: 5px;
      font-size: 12px;
      line-height: 20px;
    }

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }

  /* "Active" cells are the targets the instructor has set a value
     for on this round. We amplify them so it's obvious at a glance
     which metrics this round is grading on. */
  ${p => p.active && `
    input {
      border: 2px solid #2563EB;
      padding: 4px 11px;
      background: #EFF6FF;
      color: #0F172A;
      box-shadow: 0 2px 6px rgba(37, 99, 235, 0.12);
    }
  `}
`;

export const NAItem = styled.div`
  padding: 17px 16px;
  background: rgba(0, 27, 43, 0.02);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.38);
  border-bottom: 1px solid #F0F0F0;
  margin: 0 auto;
  min-width: 55px;
  max-width: 92px;

  @media (max-width: 1420px) {
    padding: 12px;
    min-width: auto;
  }
`;

export const ImageContainer = styled.div`
  margin-top: 34px;
`;


// WEBPACK FOOTER //
// ./src/instructor/components/grading/components/ui.js